/**
 * `wpp::tree.item`
 *
 * Only the open/closed state of one branch. Selection belongs to the tree.
 *
 * @param {boolean} open
 */
export default (open = false) => ({
    open,

    toggle() {
        this.open = ! this.open;
    },
});
